import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import "../styles/ManageMember.css";
import { useLocation } from "react-router-dom";
import { customerService } from "../services/customerServices";

function CustomerWalletSummary() {
  const [activeTab, setActiveTab] = useState("customer"); // "customer", "mini customer", "senior customer"
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();

  // If a customer was passed in location.state
  const preselectedCustomer = location.state?.customer;

  useEffect(() => {
    if (preselectedCustomer) {
      const id = preselectedCustomer.Customer_id || preselectedCustomer.id || preselectedCustomer.customer_id;
      if (id) {
        setSearch(String(id));
      }
      if (preselectedCustomer.agent_type === "mini" || preselectedCustomer.is_mini) {
        setActiveTab("mini customer");
      } else if (preselectedCustomer.agent_type === "senior" || preselectedCustomer.is_senior) {
        setActiveTab("senior customer");
      }
    }
  }, [preselectedCustomer]);

  useEffect(() => {
    const fetchWallets = async () => {
      setLoading(true);
      try {
        const params = {
          page: currentPage,
          per_page: 10,
          tab: activeTab,
          ...(search && { search: search.trim() }),
        };

        const response = await customerService.getCustomerWalletSummary(params);
        const rows = response.data || (Array.isArray(response) ? response : []);
        setSummaryData(rows);
        setTotalCount(response.total || rows.length);
        setTotalPages(response.last_page || 1);
      } catch (error) {
        console.error("Error fetching customer wallet summary:", error);
        setSummaryData([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchWallets();
  }, [search, currentPage, activeTab]);

  const getTabTitle = () => {
    if (activeTab === "mini customer") return "Mini Ads Agent";
    if (activeTab === "senior customer") return "Senior Ads Agent";
    return "Customer";
  };

  return (
    <div className="manage-member-layout">
      <SideBar />
      <div className="main-content">
        <div className="header-bar" style={{ border: 0, boxShadow: "none" }}>
          <div className="header-top">
            <h2 className="header-title">View TopCoins at a Glance</h2>
            {/* <button
              className="action-btn"
              onClick={() => navigate("/manage-customer")}
            >
              Manage Customers &gt;&gt;
            </button> */}
          </div>

          {/* Statistics Section (consistent with ManageCustomer.jsx) */}
          {/* <div className="user-statistics">
            <div className="stat-item">
              <span className="stat-label">Total {getTabTitle()}s:</span>
              <span className="stat-value">{totalCount}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Target per Wallet:</span>
              <span className="stat-value">5,000 TC</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Milestone Rule:</span>
              <span className="stat-value">250 TC / £1.25</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Current Page:</span>
              <span className="stat-value">{summaryData.length}</span>
            </div>
          </div> */}

          {/* Filter Bar with Search */}
          <div className="filters">
            <div className="input-group">
              <label>Search:</label>
              <input
                type="text"
                placeholder="Search by ID, name, or email"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                className="search-input"
                maxLength={40}
              />
            </div>
          </div>

          {/* Category Tabs: Customer, Mini Customer, Senior Customer */}
          <div className="agent-top-bar" style={{ marginTop: "20px" }}>
            <div className="top-buttons">
              <button
                className={`tab-btn ${activeTab === "customer" ? "active" : ""}`}
                style={{paddingTop:"5px", paddingBottom:"35px"}}
                onClick={() => {
                  setActiveTab("customer");
                  setCurrentPage(1);
                }}
              >
                View TopCoins at a Glance (Customers)
              </button>
              <button
                className={`tab-btn ${activeTab === "mini customer" ? "active" : ""}`}
                style={{paddingTop:"5px", paddingBottom:"35px"}}
                onClick={() => {
                  setActiveTab("mini customer");
                  setCurrentPage(1);
                }}
              >
                View TopCoins at a Glance (Mini Ads Agents)
              </button>
              <button
                className={`tab-btn ${activeTab === "senior customer" ? "active" : ""}`}
                style={{paddingTop:"5px", paddingBottom:"35px"}}
                onClick={() => {
                  setActiveTab("senior customer");
                  setCurrentPage(1);
                }}
              >
                View TopCoins at a Glance (Senior Ads Agents)
              </button>
            </div>
          </div>
        </div>

        {/* Table Container (using standard .member-table from ManageMember.css) */}
        <div className="table-container">
          <table className="member-table">
            <thead>
              <tr>
                {/* <th style={{ width: "50px", textAlign: "center" }}>No</th> */}
                <th style={{ width: "130px" }}>ID</th>
                <th style={{ minWidth: "170px" }}>Customer</th>
                <th style={{ width: "110px", textAlign: "center" }}>Role</th>
                <th style={{ width: "100px", textAlign: "center" }}>Type</th>
                <th style={{ width: "130px", textAlign: "center" }}>
                  Target (TC)
                </th>
                <th style={{ width: "120px", textAlign: "center" }}>
                  Earned TC
                </th>
                <th style={{ width: "120px", textAlign: "center" }}>
                  Redeemed TC
                </th>
                <th style={{ width: "140px", textAlign: "center" }}>
                  Collected (250 TC)
                </th>
                <th style={{ width: "160px", textAlign: "center" }}>
                  Rewards Taken Out
                </th>
                <th style={{ width: "130px", textAlign: "center" }}>
                  Balance TC Left
                </th>
                <th style={{ width: "130px", textAlign: "center" }}>
                  Earnable TC
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    <div className="loading-message">
                      Loading {getTabTitle()} Customer Wallet Details...
                    </div>
                  </td>
                </tr>
              ) : summaryData.length > 0 ? (
                summaryData.map((item, index) => {
                  const rowNumber = (currentPage - 1) * 10 + index + 1;
                  const roleBadgeText =
                    item.customer_type === "mini customer" || item.agent_type === "mini"
                      ? "Mini Ads Agent"
                      : item.customer_type === "senior customer" || item.agent_type === "senior"
                      ? "Senior Ads Agent"
                      : "Customers";

                  const roleBadgeColor =
                    item.customer_type === "mini customer" || item.agent_type === "mini"
                      ? { bg: "#fef3c7", text: "#b45309" }
                      : item.customer_type === "senior customer" || item.agent_type === "senior"
                      ? { bg: "#ede9fe", text: "#6d28d9" }
                      : { bg: "#f1f5f9", text: "#475569" };

                  return (
                    <tr
                      key={item.customer_id || index}
                      style={{ cursor: "default" }}
                    >
                      {/* <td style={{ textAlign: "center", fontWeight: "600" }}>
                        {rowNumber}
                      </td> */}
                      <td style={{ fontWeight: "700", color: "rgba(5, 44, 101, 1)" }}>
                        {item.customer_id}
                      </td>
                      <td>
                        <div style={{ fontWeight: "600" }}>
                          {item.customer_name || "N/A"}
                        </div>
                        {item.email && (
                          <div style={{ fontSize: "12px", color: "#64748b" }}>
                            {item.email}
                          </div>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          style={{
                            background: roleBadgeColor.bg,
                            color: roleBadgeColor.text,
                            padding: "4px 8px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {roleBadgeText}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          style={{
                            background: "#e0f2fe",
                            color: "#0369a1",
                            padding: "4px 8px",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                          }}
                        >
                          {item.type || "TopCoin"}
                        </span>
                      </td>
                      <td style={{ textAlign: "center", fontWeight: "600" }}>
                        {(item.target || 5000).toLocaleString()}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: "700",
                          color: "rgba(0, 0, 160, 1)",
                        }}
                      >
                        {(item.earned_tc ?? 0).toLocaleString()}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: "600" }}>
                        {(item.redeemed_tc ?? 0).toLocaleString()}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: "700" }}>
                        {item.collected_milestones ?? 0}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: "700",
                          color: "#15803d",
                        }}
                      >
                        £{(Number(item.rewards_taken_out) || 0).toFixed(2)}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: "700",
                          color: "rgba(0, 0, 160, 1)",
                        }}
                      >
                        {(item.balance_tc ?? 0).toLocaleString()}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: "600" }}>
                        {(item.earnable_tc ?? 0).toLocaleString()}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center", padding: "30px" }}>
                    No {getTabTitle().toLowerCase()} wallet details found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination (consistent with ManageMember.css) */}
          {!loading && totalCount > 0 && totalPages > 1 && (
            <div className="pagination">
              <button
                className="page-btn"
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
              >
                &lt;
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`page-btn ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="page-btn"
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                &gt;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerWalletSummary;
